<template>
  <div class="register-container">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-8 col-lg-6">
          <div class="card shadow">
            <div class="card-body p-4">
              <div class="text-center mb-4">
                <h2 class="card-title">Regisztráció</h2>
                <p class="text-muted">Partner portál</p>
              </div>

              <form @submit.prevent="handleRegister">
                <div class="row">
                  <div class="col-md-6 mb-3">
                    <label for="firstName" class="form-label">Keresztnév</label>
                    <input
                      type="text"
                      class="form-control"
                      id="firstName"
                      v-model="form.firstName"
                      :class="{ 'is-invalid': errors.firstName }"
                      :disabled="companyLoading"
                      required
                    >
                    <div v-if="errors.firstName" class="invalid-feedback">
                      {{ errors.firstName }}
                    </div>
                  </div>

                  <div class="col-md-6 mb-3">
                    <label for="lastName" class="form-label">Vezetéknév</label>
                    <input
                      type="text"
                      class="form-control"
                      id="lastName"
                      v-model="form.lastName"
                      :class="{ 'is-invalid': errors.lastName }"
                      :disabled="companyLoading"
                      required
                    >
                    <div v-if="errors.lastName" class="invalid-feedback">
                      {{ errors.lastName }}
                    </div>
                  </div>
                </div>

                <div class="mb-3">
                  <label for="email" class="form-label">E-mail cím</label>
                  <input
                    type="email"
                    class="form-control"
                    id="email"
                    v-model="form.email"
                    :class="{ 'is-invalid': errors.email }"
                    :disabled="companyLoading"
                    required
                  >
                  <div v-if="errors.email" class="invalid-feedback">
                    {{ errors.email }}
                  </div>
                </div>

                <!-- Telefonszám mező -->
                <div class="mb-3">
                  <label for="phone" class="form-label">Telefonszám</label>
                  <input
                    type="tel"
                    class="form-control"
                    id="phone"
                    v-model="form.phone"
                    :class="{ 'is-invalid': errors.phone }"
                    :disabled="companyLoading"
                    placeholder="+36-30/123-4567"
                    maxlength="17"
                    @input="formatPhoneNumber"
                  >
                  <div v-if="errors.phone" class="invalid-feedback">
                    {{ errors.phone }}
                  </div>
                  <div class="form-text">
                    Formátum: +36-30/123-4567 vagy +36-1/123-4567 (opcionális)
                  </div>
                </div>

                <!-- Adószám mező -->
                <div class="mb-3">
                  <label for="vatNumber" class="form-label">
                    Adószám
                    <span v-if="companyLoading" class="text-muted">
                      <i class="fas fa-spinner fa-spin ms-2"></i>
                      Ellenőrzés...
                    </span>
                    <span v-if="companyFound" class="text-success">
                      <i class="fas fa-check ms-2"></i>
                      Találat
                    </span>
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    id="vatNumber"
                    v-model="form.vatNumber"
                    :class="{ 
                      'is-invalid': errors.vatNumber,
                      'is-valid': companyFound && !errors.vatNumber
                    }"
                    placeholder="12345678-2-08"
                    maxlength="13"
                    @input="onVatNumberChange"
                    required
                  >
                  <div v-if="errors.vatNumber" class="invalid-feedback">
                    {{ errors.vatNumber }}
                  </div>
                  <div class="form-text">
                    Formátum: 12345678-2-08
                  </div>
                </div>

                <!-- Cégnév mező -->
                <div class="mb-3">
                  <label for="company" class="form-label">Cégnév</label>
                  <input
                    type="text"
                    class="form-control"
                    id="company"
                    v-model="form.company"
                    :class="{ 'is-invalid': errors.company }"
                    :disabled="companyLoading"
                    required
                  >
                  <div v-if="errors.company" class="invalid-feedback">
                    {{ errors.company }}
                  </div>
                </div>

                <!-- Cím mezők -->
                <div class="row">
                  <div class="col-md-4 mb-3">
                    <label for="postalCode" class="form-label">Irányítószám</label>
                    <input
                      type="text"
                      class="form-control"
                      id="postalCode"
                      v-model="form.postalCode"
                      :class="{ 'is-invalid': errors.postalCode }"
                      :disabled="companyLoading"
                      maxlength="4"
                    >
                    <div v-if="errors.postalCode" class="invalid-feedback">
                      {{ errors.postalCode }}
                    </div>
                  </div>

                  <div class="col-md-8 mb-3">
                    <label for="city" class="form-label">Város</label>
                    <input
                      type="text"
                      class="form-control"
                      id="city"
                      v-model="form.city"
                      :class="{ 'is-invalid': errors.city }"
                      :disabled="companyLoading"
                    >
                    <div v-if="errors.city" class="invalid-feedback">
                      {{ errors.city }}
                    </div>
                  </div>
                </div>

                <div class="mb-3">
                  <label for="address" class="form-label">Utca, házszám</label>
                  <input
                    type="text"
                    class="form-control"
                    id="address"
                    v-model="form.address"
                    :class="{ 'is-invalid': errors.address }"
                    :disabled="companyLoading"
                  >
                  <div v-if="errors.address" class="invalid-feedback">
                    {{ errors.address }}
                  </div>
                </div>

                <div class="row" v-if="false">
                  <div class="col-md-6 mb-3">
                    <label for="password" class="form-label">Jelszó</label>
                    <input
                      type="password"
                      class="form-control"
                      id="password"
                      v-model="form.password"
                      :class="{ 'is-invalid': errors.password }"
                      :disabled="companyLoading"
                      required
                    >
                    <div v-if="errors.password" class="invalid-feedback">
                      {{ errors.password }}
                    </div>
                  </div>

                  <div class="col-md-6 mb-3">
                    <label for="confirmPassword" class="form-label">Jelszó megerősítése</label>
                    <input
                      type="password"
                      class="form-control"
                      id="confirmPassword"
                      v-model="form.confirmPassword"
                      :class="{ 'is-invalid': errors.confirmPassword }"
                      :disabled="companyLoading"
                      required
                    >
                    <div v-if="errors.confirmPassword" class="invalid-feedback">
                      {{ errors.confirmPassword }}
                    </div>
                  </div>
                </div>

                <div class="mb-3 form-check">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    id="terms"
                    v-model="form.acceptTerms"
                    :class="{ 'is-invalid': errors.acceptTerms }"
                    :disabled="companyLoading"
                    required
                  >
                  <label class="form-check-label" for="terms">
                    Elfogadom az 
                    <a href="#" @click.prevent="showTermsModal" class="text-decoration-none">
                      Általános Szerződési Feltételeket
                    </a>
                  </label>
                  <div v-if="errors.acceptTerms" class="invalid-feedback">
                    {{ errors.acceptTerms }}
                  </div>
                </div>

                <button
                  type="submit"
                  class="btn btn-primary w-100"
                  :disabled="loading || companyLoading"
                >
                  <span v-if="loading" class="spinner-border spinner-border-sm me-2"></span>
                  Regisztráció
                </button>
              </form>

              <div class="text-center mt-3">
                <p class="mb-0">
                  Már van fiókod? 
                  <router-link to="/login" class="text-decoration-none">
                    Jelentkezz be itt
                  </router-link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import authService from '@/services/authService'
import apiService from '@/services/apiService'
import Swal from 'sweetalert2'
import termsAndConditions from '@/data/terms'

export default {
  name: 'RegisterView',
  data() {
    return {
      form: {
        firstName: '',
        lastName: '',
        email: '',
        vatNumber: '',
        company: '',
        postalCode: '',
        city: '',
        address: '',
        password: '',
        confirmPassword: '',
        acceptTerms: false,
        phone: ''
      },
      errors: {},
      loading: false,
      companyLoading: false,
      companyFound: false,
      vatNumberTimeout: null
    }
  },
  methods: {
    showTermsModal() {
      Swal.fire({
        title: 'Általános Szerződési Feltételek',
        html: `
          <div style="text-align: left; max-height: 60vh; overflow-y: auto; padding: 20px; line-height: 1.6;">
            ${this.convertMarkdownToHtml(termsAndConditions)}
          </div>
        `,
        width: '90%',
        confirmButtonText: 'Bezárás',
        confirmButtonColor: '#0d6efd',
        customClass: {
          htmlContainer: 'terms-modal-content'
        }
      })
    },

    convertMarkdownToHtml(markdown) {
      let html = markdown
        // H1 címsorok
        .replace(/^# (.+)$/gm, '<h2 style="color: #333; margin-top: 20px; margin-bottom: 10px; font-size: 1.5em;">$1</h2>')
        // H2 címsorok
        .replace(/^## (.+)$/gm, '<h3 style="color: #444; margin-top: 18px; margin-bottom: 8px; font-size: 1.3em;">$1</h3>')
        // H3 címsorok
        .replace(/^### (.+)$/gm, '<h4 style="color: #555; margin-top: 15px; margin-bottom: 7px; font-size: 1.1em;">$1</h4>')
        // H4 címsorok
        .replace(/^#### (.+)$/gm, '<h5 style="color: #666; margin-top: 12px; margin-bottom: 6px; font-size: 1em; font-weight: bold;">$1</h5>')
        // Bold szöveg
        .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
        // Horizontális vonal
        .replace(/^---$/gm, '<hr style="margin: 20px 0; border: none; border-top: 1px solid #ddd;">')
        // Email linkek
        .replace(/([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+)/g, '<a href="mailto:$1" style="color: #0d6efd;">$1</a>')
        // URL linkek
        .replace(/(https?:\/\/[^\s]+)/g, '<a href="$1" target="_blank" style="color: #0d6efd;">$1</a>')
        // Listaelemek
        .replace(/^[-•] (.+)$/gm, '<li style="margin-left: 20px;">$1</li>')

      // Táblázatok kezelése
      const tableRegex = /\|(.+)\|\n\|[-:\s|]+\|\n((?:\|.+\|\n?)+)/g
      html = html.replace(tableRegex, (match, header, rows) => {
        const headers = header.split('|').filter(h => h.trim()).map(h => h.trim())
        const rowsArray = rows.trim().split('\n').map(row => 
          row.split('|').filter(cell => cell.trim()).map(cell => cell.trim())
        )

        let table = '<table style="width: 100%; border-collapse: collapse; margin: 15px 0;">'
        table += '<thead><tr>'
        headers.forEach(h => {
          table += `<th style="border: 1px solid #ddd; padding: 10px; background-color: #f8f9fa; text-align: left; font-weight: bold;">${h}</th>`
        })
        table += '</tr></thead><tbody>'
        
        rowsArray.forEach(row => {
          table += '<tr>'
          row.forEach(cell => {
            table += `<td style="border: 1px solid #ddd; padding: 10px; vertical-align: top;">${cell}</td>`
          })
          table += '</tr>'
        })
        
        table += '</tbody></table>'
        return table
      })

      // Listák befejezése
      html = html.replace(/(<li[^>]*>.*<\/li>\n)+/g, (match) => {
        return '<ul style="list-style-type: disc; padding-left: 20px; margin: 10px 0;">' + match + '</ul>'
      })

      // Többszörös sortörések cseréje
      html = html.replace(/\n\n+/g, '<br><br>')
      // Egyszeri sortörések
      html = html.replace(/\n/g, '<br>')

      return html
    },

    onVatNumberChange() {
      // Debounce: várunk 500ms-ot a gépelés után
      clearTimeout(this.vatNumberTimeout)
      this.companyFound = false
      
      // Csak akkor ellenőrizzük, ha legalább 8 karakter van
      if (this.form.vatNumber.length >= 8) {
        this.vatNumberTimeout = setTimeout(() => {
          this.checkCompanyDetails()
        }, 500)
      } else {
        // Ha kevesebb mint 8 karakter, töröljük a cég adatokat
        this.clearCompanyData()
      }
    },

    async checkCompanyDetails() {
      if (this.form.vatNumber.length < 8) return

      this.companyLoading = true
      this.errors.vatNumber = ''

      try {
        // Az első 8 karaktert használjuk az API híváshoz
        const vatNumberBase = this.form.vatNumber.substring(0, 8)
        const response = await apiService.get(`/company-details/${vatNumberBase}`)

        if (response.success && response.data) {
          this.fillCompanyData(response.data)
          this.companyFound = true
        } else {
          this.errors.vatNumber = 'Nem található cég ezzel az adószámmal'
          this.clearCompanyData()
        }
      } catch (error) {
        console.error('Cég adatok lekérése sikertelen:', error)
        this.errors.vatNumber = 'Hiba történt a cég adatok ellenőrzése során'
        this.clearCompanyData()
      } finally {
        this.companyLoading = false
      }
    },

    fillCompanyData(data) {
      // Cégnév beállítása
      if (data.company_name && data.company_name.length > 0) {
        this.form.company = data.company_name[0]
      }

      // Irányítószám beállítása
      if (data.postal_code && data.postal_code.length > 0) {
        this.form.postalCode = data.postal_code[0]
      }

      // Város beállítása
      if (data.city && data.city.length > 0) {
        this.form.city = data.city[0]
      }

      // Cím összeállítása
      let address = ''
      if (data.address) {
        address = data.address
      }
      if (data.floor && data.floor.trim()) {
        address += ` ${data.floor}`
      }
      if (data.door && data.door.trim()) {
        address += ` ${data.door}`
      }
      this.form.address = address

      // Sikeres üzenet
      Swal.fire({
        icon: 'success',
        title: 'Cég adatok betöltve!',
        text: `${this.form.company} adatai sikeresen betöltődtek.`,
        timer: 2000,
        showConfirmButton: false,
        toast: true,
        position: 'top-end'
      })
    },

    clearCompanyData() {
      this.form.company = ''
      this.form.postalCode = ''
      this.form.city = ''
      this.form.address = ''
      this.companyFound = false
    },

    formatPhoneNumber() {
      // Eltávolítjuk az összes nem számjegyet a +36 kivételével
      let value = this.form.phone.replace(/[^\d+]/g, '')
      
      // Ha nem +36-tal kezdődik, hozzáadjuk
      if (!value.startsWith('+36')) {
        if (value.startsWith('36')) {
          value = '+' + value
        } else if (value.startsWith('06')) {
          value = '+36' + value.substring(2)
        } else if (value.length > 0 && !value.startsWith('+')) {
          value = '+36' + value
        } else if (value === '') {
          value = ''
        }
      }
      
      // Formázás alkalmazása
      if (value.length >= 3) {
        // +36 rész
        let formatted = '+36'
        let remaining = value.substring(3)
        
        if (remaining.length > 0) {
          formatted += '-'
          
          // Következő 1-2 számjegy (körzetszám)
          if (remaining.length === 1 && remaining === '1') {
            // Budapest esetén: +36-1
            formatted += remaining
          } else if (remaining.length >= 2) {
            // Mobilszám esetén: +36-30, +36-20, stb.
            formatted += remaining.substring(0, 2)
            remaining = remaining.substring(2)
            
            if (remaining.length > 0) {
              formatted += '/'
              
              // Következő 3 számjegy
              if (remaining.length >= 3) {
                formatted += remaining.substring(0, 3)
                remaining = remaining.substring(3)
                
                if (remaining.length > 0) {
                  formatted += '-'
                  // Utolsó 4 számjegy
                  formatted += remaining.substring(0, 4)
                }
              } else {
                formatted += remaining
              }
            }
          } else {
            formatted += remaining
          }
        }
        
        this.form.phone = formatted
      } else {
        this.form.phone = value
      }
    },

    validateForm() {
      this.errors = {}

      // Telefonszám formátum ellenőrzése (ha meg van adva)
      if (this.form.phone && this.form.phone.trim() !== '') {
        const phonePattern = /^\+36-(\d{1,2})\/\d{3}-\d{4}$/
        if (!phonePattern.test(this.form.phone.trim())) {
          this.errors.phone = 'Helytelen telefonszám formátum (+36-30/123-4567 vagy +36-1/123-4567)'
        }
      }

      // Adószám formátum ellenőrzése
      const vatNumberPattern = /^\d{8}-\d-\d{2}$/
      if (!vatNumberPattern.test(this.form.vatNumber.trim())) {
        this.errors.vatNumber = 'Helytelen adószám formátum (12345678-2-08)'
      }

      // if (this.form.password !== this.form.confirmPassword) {
      //   this.errors.confirmPassword = 'A jelszavak nem egyeznek'
      // }

      // if (this.form.password.length < 6) {
      //   this.errors.password = 'A jelszónak legalább 6 karakter hosszúnak kell lennie'
      // }

      if (!this.form.acceptTerms) {
        this.errors.acceptTerms = 'El kell fogadnia az ÁSZF-et'
      }

      return Object.keys(this.errors).length === 0
    },

    async handleRegister() {
      if (!this.validateForm()) {
        return
      }

      this.loading = true

      const userData = {
        name: this.form.firstName,
        last_name: this.form.lastName,
        email: this.form.email,
        vat_number: this.form.vatNumber,
        company_name: this.form.company,
        zip_code: this.form.postalCode,
        city: this.form.city,
        address: this.form.address,
        password: this.form.password,
        phone: this.form.phone
      }

      try {
        const result = await authService.register(userData)

        console.log('Regisztrációs válasz:', result)

        if (result && (result.status === 201)) {
          await Swal.fire({
            icon: 'success',
            title: 'Sikeres regisztráció!',
            text: result.message || 'Regisztráció sikeres!',
            confirmButtonText: 'OK'
          })

          // Átirányítás a login oldalra
          this.$router.push('/login')
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Regisztrációs hiba',
            text: result ? result.message : 'Ismeretlen hiba történt'
          })
        }
      } catch (error) {
        console.error('Regisztrációs hiba:', error)
        Swal.fire({
          icon: 'error',
          title: 'Regisztrációs hiba',
          text: 'Hiba történt a regisztráció során'
        })
      }

      this.loading = false
    }
  },

  beforeUnmount() {
    // Timeout törlése komponens eltávolításakor
    if (this.vatNumberTimeout) {
      clearTimeout(this.vatNumberTimeout)
    }
  }
}
</script>

<!-- Használja a public/css/register.css fájlt -->
<style scoped>
@import url('/public/css/register.css');

:deep(.terms-modal-content) {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  font-size: 14px;
  color: #333;
}

:deep(.terms-modal-content table) {
  font-size: 13px;
}

:deep(.terms-modal-content h2),
:deep(.terms-modal-content h3),
:deep(.terms-modal-content h4),
:deep(.terms-modal-content h5) {
  font-weight: 600;
}

:deep(.terms-modal-content a) {
  text-decoration: none;
}

:deep(.terms-modal-content a:hover) {
  text-decoration: underline;
}
</style>
